import store from '../../../store/index'
import toast from "./toast";
import confirm from "./confirm";
import user_profile from "../user/modal/user_profile";
import users_filter from "../users/index.vue";
import editor from "../editor/editor.vue";



window.IMC_VUE_SYS =  new Vue({
	store,
	el: '#imc_app',
	name : "IMC_APP_SYS",
	data () {
		return {

		}
	},
	created () {

	},
	components : {
		editor,
		user_profile,
		toast,
		confirm,
		users_filter,
	}
});
